import { render, staticRenderFns } from "./importPlan.vue?vue&type=template&id=c206a98a&scoped=true&"
import script from "./importPlan.vue?vue&type=script&lang=js&"
export * from "./importPlan.vue?vue&type=script&lang=js&"
import style0 from "./importPlan.vue?vue&type=style&index=0&id=c206a98a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c206a98a",
  null
  
)

export default component.exports